import './CenterPopup.less'
import CenterPopup from './CenterPopup'

export type { CenterPopupProps } from './iCenterPopup'

export default CenterPopup
